export default __webpack_public_path__ + "26db4a1531a9fd23ed15f6a04fca89b8.svg";